import apiService from '@/util/request.js';

/** module that contains functions for dealing with location endpoints
 * @module locationApiService */

/**
 * fetch location by id
 * @param {String} locationId location id
 * @returns {AxiosPromise<any>}
 */
const getLocation = (locationId) => {
  return apiService.get(`/smp/api/locations/${locationId}`);
};

/**
 * fetch contact info by dmsCustomerCode
 * @param {String} code dmsCustomerCode
 * @returns {AxiosPromise<any>}
 */
const getContactInfo = (code) => {
  return apiService.get(`/smp/api/tyre-change/personal-data/${code}`).then((res) => res.data);
};

/**
 * fetch service prices
 * @param {String} locationId id of a location
 * @param {Object[]} services objects with externalId of a service { externalId: service.externalId }
 * @returns {AxiosPromise<any>}
 */
const getServicePrices = (services, locationId) => {
  return apiService.post(`/smp/api/locations/${locationId}/services/price`, services);
};

/**
 * fetch location capabilities (eg if contact request is enabled)
 * @param {String[]} locationIds id of a location
 * @returns {AxiosPromise<any>}
 */
const getCapabilities = locationIds => {
  return apiService.get('/smp/api/locations-info/capabilities', { params: { locationIds } })
}

const locationApiService = {
  getLocation,
  getContactInfo,
  getServicePrices,
  getCapabilities
};

export default locationApiService;
